import { Component, StrictMode } from 'react'
import type { ErrorInfo, ReactNode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './ui/App'

class AppBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false }
  static getDerivedStateFromError() { return { failed: true } }
  componentDidCatch(error: Error, info: ErrorInfo) { console.error('Museum error', error, info.componentStack) }
  render() {
    if (this.state.failed) return <main style={{ padding: '48px', fontFamily: 'sans-serif' }}><h1>展馆暂时无法打开</h1><p>已保存的档案仍留在此浏览器。请刷新页面再试。</p><button onClick={() => location.reload()}>重新加载</button></main>
    return this.props.children
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode><AppBoundary><App /></AppBoundary></StrictMode>,
)
